import { CARD_STYLES } from '../../../utils/constants/CSS/cardStyles'

const dashboardStyles = {
  loader: CARD_STYLES.loader,
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}

export default dashboardStyles
